import { Helper } from "../app/core/util/helper.js";
import { Drawer } from "./drawer.js";
import ReactDOM from "react-dom";
export class DrawerContent {
    private _hasValue = Helper.hasValue;
    private _element: JQuery = null;
    private _visible = false;
    private _afterAnimationEnd: Function = null
    private _noAnimation = false;
    private _parentClass: Drawer = null;
    private _customWidth: number | string = null;
    private _unmountOnRemove = false;
    private _hiddenContainer: JQuery = null;


    constructor(parent: Drawer, hiddenContainer: JQuery) {
        this._element = $("<div>").addClass("drawer__content").addClass("drawer__content--hidden");
        this._parentClass = parent;
        this._element.on("animationend", this._onAnimationEnd);
        this._hiddenContainer = hiddenContainer;
    }


    private _onAnimationEnd = (je: JQueryEventObject) => {
        if (!this._hasValue(je) || je.target === this._element[0]) {
            this._element.removeClass("tabStrip-elem-loading").removeClass("tabStrip-elem-exiting");

            if (this._afterAnimationEnd) {
                this._afterAnimationEnd();
            }
        }
    }

    private _cleanUp = () => {
        if (this._unmountOnRemove) {
            ReactDOM.unmountComponentAtNode(this._element[0]);
        }
        if (this._element) {
            this._element.off("animationend");
            this._element.remove();
            this._element = null;
        }
        this._parentClass.removeContent(this);
        this._parentClass.updateWidth();
    }

    private _setAfterAnimationCallback = (callback: Function) => {
        this._afterAnimationEnd = () => {
            if (callback) {
                callback();
            }

            if (!this._visible) {
                this._hiddenContainer.append(this._element);
            }
        }
    }


    disableAnimation = () => {
        this._noAnimation = true;
    }

    enableAnimation = () => {
        this._noAnimation = false;
    }

    hide = (afterAnimation?: Function, force?: boolean) => {
        if (this._visible || force) {
            this._visible = false;
            this._parentClass.updateWidth();
            this._setAfterAnimationCallback(afterAnimation);
            if (this._noAnimation) {
                this._element.addClass("drawer__content--hidden");
                this._onAnimationEnd(null);
            } else {
                this._element.addClass("tabStrip-elem-exiting");
            }
        }
    }

    show = (afterAnimation?: Function) => {
        if (!this._visible) {
            this._visible = true;
            this._parentClass.updateWidth();
            this._setAfterAnimationCallback(afterAnimation);
            this._parentClass.elements.getContentWrapper().append(this._element);
            if (this._noAnimation) {
                this._element.removeClass("drawer__content--hidden");
                this._onAnimationEnd(null);
            } else {
                this._element.addClass("tabStrip-elem-loading").removeClass("drawer__content--hidden");
            }
        }
    }

    remove = () => {
        if (this._visible) {
            this.hide(() => {
                this._cleanUp();
            });
        } else {
            this._cleanUp();
        }
    }

    getElement = () => {
        return this._element;
    }

    getCustomWidth = () => {
        return this._customWidth;
    }

    setWidth = (width: number | string) => {
        this._customWidth = width;
        this._parentClass.updateWidth();
    }

    isVisible = () => {
        return this._visible;
    }

    unmountOnRemove = (on: boolean) => {
        this._unmountOnRemove = on;
    }
}